import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LogoutOutlined } from '@ant-design/icons';
import { useTheme } from './ParticleBackground';
import ThemeToggle from './ThemeToggle';
import ekahLogo from '../assets/ekah-single.jpg';

const MobileHeader = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { logout } = useAuth();

    const handleLogout = async () => {
        try {
            await logout();
            navigate('/signin');
        } catch (error) {
            console.error('Failed to log out', error);
        }
    };
    const { getThemeStyles } = useTheme();
    const themeStyles = getThemeStyles();

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            height: '60px',
            background: themeStyles.headerBg,
            borderBottom: `1px solid ${themeStyles.headerBorder}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 16px',
            zIndex: 1000,
            backdropFilter: 'blur(20px)'
        }}>
            {/* Logo */}
            <div
                onClick={() => navigate('/')}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    cursor: 'pointer'
                }}
            >
                <img
                    src={ekahLogo}
                    alt="Ekah"
                    style={{
                        width: '32px',
                        height: '32px',
                        borderRadius: '8px',
                        objectFit: 'cover'
                    }}
                />
                <span style={{
                    fontSize: '18px',
                    fontWeight: '700',
                    color: themeStyles.textPrimary,
                    letterSpacing: '-0.5px'
                }}>
                    EkahHealth
                </span>
            </div>

            {/* Actions */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                {location.pathname === '/profile' && (
                    <div
                        onClick={handleLogout}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                            padding: '6px 16px',
                            background: 'rgba(255, 77, 79, 0.15)', // bright red background
                            borderRadius: '24px', // pill shape
                            cursor: 'pointer',
                            color: '#ff4d4f', // bright red text
                            fontWeight: '600',
                            fontSize: '14px',
                            transition: 'all 0.2s ease',
                            border: '1px solid rgba(255, 77, 79, 0.2)'
                        }}
                    >
                        <span style={{ lineHeight: 1 }}>Logout</span>
                        <LogoutOutlined style={{ fontSize: '14px' }} />
                    </div>
                )}
                <ThemeToggle />
            </div>
        </div>
    );
};

export default MobileHeader;
